// extracted by mini-css-extract-plugin
var _1 = "section-theme-provider-module__theme-black__yNjz4";
var _2 = "section-theme-provider-module__theme-dark-green__aHYZ9";
var _3 = "section-theme-provider-module__theme-dark-orange__Fsf5D";
var _4 = "section-theme-provider-module__theme-dark-pink__CNHm0";
var _5 = "section-theme-provider-module__theme-dark-yellow__YyRdB";
var _6 = "section-theme-provider-module__theme-default__u1TuV";
var _7 = "section-theme-provider-module__theme-green__LPnGb";
var _8 = "section-theme-provider-module__theme-light__sLg7_";
var _9 = "section-theme-provider-module__theme-orange__yaZqe";
var _a = "section-theme-provider-module__theme-pink__lz9SX";
var _b = "section-theme-provider-module__theme-yellow__X1FKf";
export { _1 as "theme-black", _2 as "theme-dark-green", _3 as "theme-dark-orange", _4 as "theme-dark-pink", _5 as "theme-dark-yellow", _6 as "theme-default", _7 as "theme-green", _8 as "theme-light", _9 as "theme-orange", _a as "theme-pink", _b as "theme-yellow" }
export default { "theme-black": _1, "theme-dark-green": _2, "theme-dark-orange": _3, "theme-dark-pink": _4, "theme-dark-yellow": _5, "theme-default": _6, "theme-green": _7, "theme-light": _8, "theme-orange": _9, "theme-pink": _a, "theme-yellow": _b }
